import React from 'react';
import { StyleProp, Text, TextStyle } from 'react-native';
import styles from './Heading.styles';

const Heading: React.FC<{
  variant?: 'page' | 'section' | 'alert' | 'subSection';
  style?: StyleProp<TextStyle>;
  children?: React.ReactNode;
}> = ({ children, variant = 'section', style }) => (
  <Text style={[styles[variant], style]}>{children}</Text>
);

export default Heading;
